import { jsx, jsxs } from "react/jsx-runtime";

const k = { jsx, jsxs };

export function RecentActivity({
  Title: V,
  filter: c,
  setFilter: l,
  documents: a,
  DocumentRow: xi,
  orders: t,
  tasks: n,
  onOpenOrder,
  onOpenTask,
  NextIcon: S,
}) {
  return (0, k.jsxs)(`section`, {
    className: `card activity`,
    children: [(0, k.jsx)(V, {
      title: `Actividad reciente`,
      sub: `Más reciente primero`
    }), (0, k.jsx)(`div`, {
      className: `tabs`,
      children: [`Todos`, `Oferta`, `Pedido`, `Albarán`, `Orden`, `Tarea`].map(e => (0, k.jsx)(`button`, {
        className: c === e ? `active` : ``,
        onClick: () => l(e),
        children: e === `Oferta` ? `Ofertas` : e === `Pedido` ? `Pedidos` : e === `Albarán` ? `Albaranes` : e === `Orden` ? `Órdenes` : e === `Tarea` ? `Tareas` : `Todos`
      }, e))
    }), a.map(e => (0, k.jsx)(xi, {
      d: e
    }, e.id)), (c === `Todos` || c === `Orden`) && t.map(e => (0, k.jsxs)(`button`, {
      className: `taskquick`,
      onClick: () => onOpenOrder(e),
      children: [(0, k.jsxs)(`span`, {
        children: [(0, k.jsxs)(`b`, {
          children: [e.number, ` · `, e.client]
        }), (0, k.jsxs)(`small`, {
          children: [e.date, ` · `, e.mainTech, ` · `, e.status]
        })]
      }), (0, k.jsx)(S, {})]
    }, `order-${e.id}`)), (c === `Todos` || c === `Tarea`) && n.map(e => (0, k.jsxs)(`button`, {
      className: `taskquick`,
      onClick: () => onOpenTask(e),
      children: [(0, k.jsxs)(`span`, {
        children: [(0, k.jsx)(`b`, {
          children: e.title
        }), (0, k.jsxs)(`small`, {
          children: [e.date, ` · `, e.owner, ` · `, e.status]
        })]
      }), (0, k.jsx)(S, {})]
    }, `task-${e.id}`))]
  });
}
